import React from "react";
import API from "@/apis";
import { pool_uuid, tempActivity } from "@/config.json";
import { message, Button, Table, Tooltip, Pagination, Modal, Input, Radio } from "antd";
import _ from "lodash";
import { CoinHelper, powerUnit2object, powerUnitObject, SortList } from "@/utils";
import { SessionStore, LocaleStore, RouterStore } from "@/stores";
import { inject, observer } from "mobx-react";
import "./index.less";
import MyIcon from "@/components/MyIcon";
import MButton from "@/components/CommonButton";
import ZeroRate from "@/components/ZeroRate";
import { project, assets } from "@/config.json";
import { RStatus } from "@/models";
import { loadImage } from "@/utils";

interface StoreProps {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
}

// export interface AccountListProps {
//   title: string;
//   data: any;
//   [x: string]: any;
// }

// interface Props extends StoreProps, AccountListProps { }
interface Props extends StoreProps {}

@inject("session", "locale", "router")
@observer
class AccountList extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  state = {
    openAdd: false,
    radioValue: "BTC",
    page: 1,
    pageSize: 10,
    subName: "",
    newAccountUrl: "",
    newStepUrl: "",
    selectedRowKeys: [],
    chooseSub: [],
    sort: "", //desc,asc
    sortType: "", //排序的类目
    showEdit: false,
  } as any;

  componentDidMount() {
    const { session } = this.props;
    loadImage(assets.newAccount).then((asset) => {
      this.setState({
        newAccountUrl: asset.default,
      });
    });
    loadImage(assets.newStep).then((asset) => {
      this.setState({
        newStepUrl: asset.default,
      });
    });
    session.getSubAccountList(); // 获取子账号列表(含主账户)
  }

  // 新增子账号
  addSub = async () => {
    const { session } = this.props;
    const { radioValue, subName } = this.state;
    try {
      const { data } = await API.User.addSubUser({
        currency: radioValue,
        user_name: subName,
      });
      session.getSubAccountList();
    } catch (error) {}
  };

  setSubShow = async (is_hidden) => {
    const { session, locale } = this.props;
    const { showEdit, chooseSub, sort, sortType } = this.state;
    // todo
    if (
      (is_hidden == 1 && chooseSub.length > 0 && chooseSub.length < session.subAccountList.total) ||
      is_hidden == 0
    ) {
      let idList = chooseSub.map((item) => {
        return item.id;
      });
      let json = {
        subuser_id: idList,
        is_hidden: is_hidden,
      };
      try {
        const { data } = await API.User.setHidden(json);
        this.chancleSubShow();
        message.success(locale.get(data.msg));
        session.getSubAccountList(sort, sortType, 0);
      } catch (error) {}
    } else {
      message.info(locale.get("MSG_hidden_sub"));
    }
  };

  chancleSubShow = () => {
    this.setState({
      showEdit: false,
      selectedRowKeys: [],
      chooseSub: [],
      page: 1,
    });
  };

  // table sort排序
  handleTableChange = (pagination, filters, sorter) => {
    const { nowGroupId } = this.state;
    const { session } = this.props;
    // console.log(sorter, nowGroupId);
    if (_.isEmpty(sorter.order)) {
      this.setState(
        {
          sort: "",
          sortType: "",
        },
        () => {
          session.getSubAccountList();
        }
      );
    } else {
      this.setState(
        {
          sort: SortList[sorter.order],
          sortType: sorter.field,
        },
        () => {
          session.getSubAccountList(SortList[sorter.order], sorter.field);
        }
      );
    }
  };

  get columns() {
    const { locale, session } = this.props;
    const { showEdit, sort, sortType } = this.state;
    return [
      {
        title: locale.get("IndexPage.Account"),
        dataIndex: "userName",
        width: "210px",
        render: (_text, record) => (
          <span
            className={`memepool-number-font ${record.is_hidden ? "show-off" : ""}`}
            style={{ wordBreak: "break-all" }}
          >
            {_text}
          </span>
        ),
        sorter: true,
      },
      {
        // align: "center",
        title: locale.get("IndexPage.MinersOnOff"),
        dataIndex: "miners",
        render: (_text, record) => (
          <div className={`${record.is_hidden ? "show-off" : ""}`}>
            <span className="color-green">{record.online_worker}</span>
            &nbsp;&frasl;&nbsp;
            <span className="color-yellow">{record.low_worker}</span>
            &nbsp;&frasl;&nbsp;
            <span className="color-red">{record.offline_worker}</span>
          </div>
        ),
        sorter: true,
      },
      {
        // align: "center",
        title: (
          <div>
            {locale.get("IndexPage.RealTime")}
            <Tooltip placement="top" title={locale.get("IndexPage.RealTimeTips")}>
              <MyIcon type="icon-faq" className="icon-info" />
            </Tooltip>
          </div>
        ),
        dataIndex: "hash_rate",
        render: (_text, record) => {
          const power =
            record.key == "total"
              ? { value: "-", unit: "TH/s" }
              : powerUnitObject(_text, record.currency);
          return (
            <div className={`${record.is_hidden ? "show-off" : ""}`}>
              <span className="memepool-number-font ">{power.value}</span>
              <span className="table-text">&nbsp;{power.unit}</span>
            </div>
          );
        },
        sorter: true,
      },
      {
        // align: "center",
        title: (
          <div>
            {locale.get("IndexPage.24hour")}
            <Tooltip placement="top" title={locale.get("IndexPage.24hourTips")}>
              <MyIcon type="icon-faq" className="icon-info" />
            </Tooltip>
          </div>
        ),
        dataIndex: "hash_rate_day",
        render: (_text, record) => {
          const power =
            record.key == "total"
              ? { value: "-", unit: "TH/s" }
              : powerUnitObject(_text, record.currency);
          return (
            <div className={`${record.is_hidden ? "show-off" : ""}`}>
              <span className="memepool-number-font ">{power.value}</span>
              <span className="table-text">&nbsp;{power.unit}</span>
            </div>
          );
        },
        sorter: true,
      },
      {
        // align: "center",
        title: (
          <div>
            {locale.get("IndexPage.CoinType")}
            <Tooltip placement="top" title={locale.get("IndexPage.changeTips")}>
              <MyIcon type="icon-faq" className="icon-info" />
            </Tooltip>
          </div>
        ),
        dataIndex: "receive_money_type",
        render: (_text, record) => (
          <div className={`${record.is_hidden ? "show-off" : ""}`}>
            {record.key == "total" ? "-" : _text}
          </div>
        ),
      },
      {
        // align: "center",
        title: locale.get("IndexPage.Last24hours"),
        dataIndex: "lastDayProfit",
        render: (_text, record) =>
          record.currency != "LTC" ? (
            <div className={`table_bolck ${record.is_hidden ? "show-off" : ""}`}>
              <div>
                <span className="memepool-number-font ">
                  {CoinHelper.amount2bsv(record.btc_profit_day)}
                </span>
                &nbsp;
                <span className="table-text">{locale.get("BTC")}</span>
              </div>
              <div>
                <span className="memepool-number-font ">
                  {CoinHelper.amount2bsv(record.bsv_profit_day)}
                </span>
                &nbsp;
                <span className="table-text">{locale.get("BSV")}</span>
              </div>
            </div>
          ) : (
            <div className={`table_bolck ${record.is_hidden ? "show-off" : ""}`}>
              <div>
                <span className="memepool-number-font ">
                  {CoinHelper.amount2bsv(record.ltc_profit_day)}
                </span>
                &nbsp;
                <span className="table-text">LTC</span>
              </div>
              <div>
                <span className="memepool-number-font ">
                  {CoinHelper.amount2bsv(record.doge_profit_day)}
                </span>
                &nbsp;
                <span className="table-text">DOGE</span>
              </div>
            </div>
          ),
      },
      {
        // align: "center",
        title: locale.get("IndexPage.Balance"),
        dataIndex: "powerConsumption",
        render: (_text, record) =>
          record.currency != "LTC" ? (
            <div className={`table_bolck ${record.is_hidden ? "show-off" : ""}`}>
              <div>
                <span className="memepool-number-font ">
                  {CoinHelper.amount2bsv(record.btc_profit_left)}
                </span>
                &nbsp;
                <span className="table-text">{locale.get("BTC")}</span>
              </div>
              <div>
                <span className="memepool-number-font ">
                  {CoinHelper.amount2bsv(record.bsv_profit_left)}
                </span>
                &nbsp;
                <span className="table-text">{locale.get("BSV")}</span>
              </div>
            </div>
          ) : (
            <div className={`table_bolck ${record.is_hidden ? "show-off" : ""}`}>
              <div>
                <span className="memepool-number-font ">
                  {CoinHelper.amount2bsv(record.ltc_profit_left)}
                </span>
                &nbsp;
                <span className="table-text">LTC</span>
              </div>
              <div>
                <span className="memepool-number-font ">
                  {CoinHelper.amount2bsv(record.doge_profit_left)}
                </span>
                &nbsp;
                <span className="table-text">DOGE</span>
              </div>
            </div>
          ),
      },
      {
        align: "right",
        title: (
          <div>
            {showEdit ? (
              <span className="button-group">
                <MButton
                  color="#F4406B"
                  colorType="red"
                  onClick={() => this.setSubShow(0)}
                  text={locale.get("IndexPage.show")}
                />
                &nbsp;
                <MButton onClick={() => this.setSubShow(1)} text={locale.get("IndexPage.hidden")} />
                <div className="table-close" onClick={this.chancleSubShow}>
                  <MyIcon type="iconclose" />
                </div>
              </span>
            ) : (
              <MButton
                onClick={() =>
                  this.setState(
                    { showEdit: true }
                    //   , () => {
                    //   session.getSubAccountList(sort, sortType, showEdit ? 1 : 0);}
                  )
                }
                text={locale.get("IndexPage.management")}
              />
            )}
          </div>
        ),
        dataIndex: "id",
        render: (_text, record, index) => (
          <div className={`${record.is_hidden ? "show-off" : ""}`}>
            {record.key == "total" && !session.isWatcherTheme ? (
              <MButton
                text={locale.get("IndexPage.Detail")}
                onClick={() => {
                  this.toMain(record);
                }}
              />
            ) : (
              <MButton
                text={locale.get("IndexPage.Detail")}
                disabled={record.is_hidden}
                onClick={() => {
                  this.todetail(record);
                }}
              />
            )}
          </div>
        ),
      },
    ] as any;
  }

  toMain = (record) => {
    const { router, session } = this.props;
    router.push("/mainAccount");
  };
  // 跳转子账户
  todetail = (record) => {
    const { router, session } = this.props;
    session.setCurrentSubAccountTabKey();
    // if (session.isWatcherTheme) {
    //   let id = record.id;
    //   localStorage.setItem("currentWatch", JSON.stringify(record));
    //   router.push(`/sub/${sessionStorage.subKey}/detail`);
    // } else {
    const { id } = record;
    // 获取子账户详情
    session.getSubAccountInfo(id).then(() => {
      router.push(`/account`);
    });
    // }
  };

  // 新增子账户名
  changeInput = (e) => {
    let subName = e.target.value.trim();
    this.setState({
      subName: subName,
    });
  };

  // 改变挖矿币种
  changeRadio = (e) => {
    // console.log(e.target.value);
    this.setState({
      radioValue: e.target.value,
    });
  };

  // 分页
  changePage = (page) => {
    const { session } = this.props;
    const { pageSize } = this.state;
    this.setState({
      page: page,
    });
    // session.getSubAccountList(page, pageSize);
  };

  changePageSize = (current, size) => {
    const { session } = this.props;
    this.setState({
      page: current,
      pageSize: size,
    });
    // session.getSubAccountList(current, size);
  };

  showModal = () => {
    this.setState({
      openAdd: true,
    });
  };
  handleOk = () => {
    this.addSub();
    this.handleCancel();
  };
  handleCancel = () => {
    this.setState({
      openAdd: false,
    });
  };

  render() {
    const { locale, session } = this.props;
    const {
      openAdd,
      page,
      pageSize,
      newAccountUrl,
      newStepUrl,
      selectedRowKeys,
      chooseSub,
      showEdit,
    } = this.state;
    const { coinEarnData, bsvHeigher, isWatcherTheme, subAccountList } = session;
    const rowSelection = {
      selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ chooseSub: selectedRows, selectedRowKeys: selectedRowKeys });
        // console.log(`selectedRowKeys: ${selectedRowKeys}`, "selectedRows: ", selectedRows);
      },
      getCheckboxProps: (record) => ({
        name: record.worker_name,
      }),
    };

    return (
      <div className="account-list">
        <div className="top">
          <div className="top-left">
            {/* <MyIcon type="icon-list" className="icon-size" /> */}
            {locale.get("IndexPage.list")}
          </div>
          {isWatcherTheme ? null : (
            <MButton
              text={
                <span>
                  <MyIcon type="iconAdd" />
                  {locale.get("IndexPage.addAccount")}
                </span>
              }
              onClick={this.showModal}
              className="right-btn"
            />
          )}
        </div>
        <section className="account-table">
          {/* subAccountList.status == RStatus.Fulfilled && */}
          {subAccountList.total > 0 ? (
            <Table
              className="center"
              columns={this.columns}
              // dataSource={data.data_list}
              dataSource={
                showEdit ? subAccountList.data : subAccountList.data.filter((x) => !x.is_hidden)
              }
              rowKey={((record) => record.key) as any}
              pagination={{
                //分页
                current: page,
                total: showEdit
                  ? subAccountList.total
                  : subAccountList.data.filter((x) => !x.is_hidden).length, //数据总数量
                pageSize: pageSize, //显示几条一页
                showSizeChanger: true,
                showQuickJumper: true,
                onChange: this.changePage,
                onShowSizeChange: this.changePageSize,
              }}
              rowSelection={rowSelection}
              onChange={this.handleTableChange}
            />
          ) : (
            <div className="no-account">
              <img src={newAccountUrl} className="img-top" />
              <div className="tips">{locale.get("IndexPage.noAccountTips1")}</div>
              <div className="tips">{locale.get("IndexPage.noAccountTips2")}</div>
              <img src={newStepUrl} className="img-step" />

              <div className="steps">{locale.get("IndexPage.steps1")}</div>
              <div className="steps pb30">{locale.get(`${project}.indexPage.steps2` as any)}</div>
              {/* <div className="rule">{locale.get(`${project}.indexPage.addressRule1` as any)}</div> */}
              <div className="rule">
                {locale.get(`${project}.indexPage.addressRule2` as any, true)}
              </div>
            </div>
          )}
        </section>
        <Modal
          width={450}
          title={<div className="center-title">{locale.get("IndexPage.addAccount")}</div>}
          visible={openAdd}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          wrapClassName="add-modal"
          destroyOnClose={true}
        >
          <Input
            placeholder={locale.get("IndexPage.accountName")}
            allowClear
            onChange={this.changeInput}
          />
          <div className="center-content">
            <div className={`add-center-text add-center-text-${locale.getLangTypeLowerCase}`}>
              {locale.get("IndexPage.chooseCoin")}
            </div>
            <Radio.Group onChange={this.changeRadio} value={this.state.radioValue}>
              <Radio value={"BTC"}>{locale.get("BTC")}</Radio>
              <Radio value={"BSV"}>{locale.get("BSV")}</Radio>
            </Radio.Group>
          </div>
          <div>
            <div className="add-center-text">{locale.get("IndexPage.Earning")}</div>
            <span className="content-text">{locale.get("BSV")}</span>
            <span className="memepool-number-font ">
              {CoinHelper.amount2bsv(coinEarnData.bsv_earn)}&nbsp;
            </span>
            <span className="content-gray">{locale.get("BSV")}</span>
            <span className="pad10">≈</span>
            <span className="memepool-number-font ">
              {CoinHelper.amount2bsv(coinEarnData.bsv_earn_tran)}&nbsp;
            </span>
            <span className="content-gray">{locale.get("BTC")}</span>
            {bsvHeigher ? (
              <span className="text-green">{locale.get("IndexPage.Higher")}</span>
            ) : null}
            <br></br>
            <span className="content-text">{locale.get("BTC")}</span>
            <span className="memepool-number-font ">
              {CoinHelper.amount2bsv(coinEarnData.btc_earn)}&nbsp;
            </span>
            <span className="content-gray">{locale.get("BTC")}</span>
            <span className="pad10">≈</span>
            <span className="memepool-number-font ">
              {CoinHelper.amount2bsv(coinEarnData.btc_earn_tran)}&nbsp;
            </span>
            <span className="content-gray">{locale.get("BSV")}</span>
            {!bsvHeigher ? (
              <span className="text-green">{locale.get("IndexPage.Higher")}</span>
            ) : null}
          </div>
        </Modal>
      </div>
    );
  }
}

// export default AccountList as React.ComponentType<AccountListProps>;
export default AccountList as React.ComponentType;
